import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled, { ThemeProvider } from 'styled-components'
import Header from '../Header'
import Hemicycle from 'components/Hemicycle/Hemicycle'
import { GlobalVariables } from 'Globals/GlobalVariables'
import LawPage from 'components/LawPage'
import Simulator from 'components/Simulator'
import MinList from 'components/MinList'
import People from 'components/People'

// https://master.dev.24heures.ch/quel-est-le-poids-de-votre-vote-963541737786?preview_key=81e3a641d7a8e5be846932ea22a97e1a

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const theme = {
    colorMain:
      colorMode === 'dark'
        ? tenant.key === '24heures'
          ? '233, 233, 233'
          : '233, 233, 233'
        : tenant.key === '24heures'
        ? '217, 1, 14'
        : '44, 56, 144',
    textColor: colorMode === 'dark' ? '233, 233, 233' : '32, 35, 70',
    textColorInverted: colorMode === 'dark' ? '32, 35, 70' : '233, 233, 233',
    colorMainDark: colorMode === 'dark' ? '253, 163, 0' : '105, 88, 104',
    grayColorLight: colorMode === 'dark' ? '56, 56, 56' : '241, 245, 249',
    grayColorMedium: colorMode === 'dark' ? '89, 89, 89' : '226, 232, 240',
    grayColorDark: colorMode === 'dark' ? '0, 0, 0' : '100, 116, 139',
    colorBlueDark: colorMode === 'dark' ? '233, 233, 233' : '32, 35, 70',
    colorMode: colorMode,
    tenant: tenant.key,
    siteBackground: colorMode === 'dark' ? '18, 18, 18' : '255, 255, 255',
  }

  const modules = {
    header: (
      <Header
        title={properties.title}
        keywords={properties.keywords}
        lead={properties.lead}
      />
    ),
    simulator: <Simulator />,
    hemicycle: <Hemicycle />,
    law: (
      <LawPage title='Mettre en place une déclaration de provenance pour les produits à base de noix de coco cueillies par des singes' />
    ),
    people: <People />,
    list: (
      <MinList
        data={
          new Map([
            [2019, 181],
            [2015, 2991],
            [2011, 624],
            [2007, 1622],
            [2003, 2553],
          ])
        }
      />
    ),
  }

  return (
    <AppContainer $colorMode={colorMode}>
      <ThemeProvider theme={theme}>{modules[properties.module]}</ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: var(--color-background);
`

export default MainComponent
